export default {
  data: function data() {
    return {
      clubList: [1, 2, 3]
    };
  },
  methods: {
    toDetail: function toDetail(val) {
      // this.$router.push({ path: '/social/detail', query: { from: val }})
      this.$toast('等待UI');
    }
  }
};